import { alert } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'alert',
  label: 'Alert',
  category: 'Feedback',
  image: alert
};
